const entities: { [key: string]: string } = {
  AGS: 'Aguascalientes',
  BC: 'Baja California',
  BCS: 'Baja California Sur',
  CAMP: 'Campeche',
  CHIS: 'Chiapas',
  CHIH: 'Chihuahua',
  CDMX: 'Ciudad de México',
  COAH: 'Coahuila',
  COL: 'Colima',
  DGO: 'Durango',
  GTO: 'Guanajuato',
  GRO: 'Guerrero',
  HGO: 'Hidalgo',
  JAL: 'Jalisco',
  'EDO MEX': 'Estado de México',
  MICH: 'Michoacán',
  MOR: 'Morelos',
  NAY: 'Nayarit',
  NL: 'Nuevo León',
  OAX: 'Oaxaca',
  PUE: 'Puebla',
  QRO: 'Querétaro',
  'Q ROO': 'Quintana Roo',
  SLP: 'San Luis Potosí',
  SIN: 'Sinaloa',
  SON: 'Sonora',
  TAB: 'Tabasco',
  TAMPS: 'Tamaulipas',
  TLAX: 'Tlaxcala',
  VER: 'Veracruz',
  YUC: 'Yucatán',
  ZAC: 'Zacatecas',
};

function transformEntity(entity: string): string | undefined {
  entity = entity.replace(/0/g, 'O').replace(/4/g, 'A');
  if (entity === 'O ROO') {
    entity = 'Q ROO';
  }

  let transformedEntity = entities[entity];
  if (transformedEntity) {
    // Right now we're uppercasing and removing special characters
    transformedEntity = transformedEntity
      .replace(/[^A-Z0-9ñ\sáéíóúü\.]+/gi, '')
      .toUpperCase()
      .replace('Á', 'A')
      .replace('É', 'E')
      .replace('Í', 'I')
      .replace('Ó', 'O')
      .replace('Ú', 'U');
  }

  return transformedEntity;
}

export default transformEntity;
